import { MutationHookOptions, useMutation } from '@apollo/client';

import { ADD_ANSWER } from './mutations';

export const useAddAnswer = (options?: MutationHookOptions) => useMutation(ADD_ANSWER, options);
